module.exports = __webpack_public_path__ + "img/btn_claim_bg.b46d0203.png";